import { ENV_CONFIG } from '../../environments/environment.config';

export const API_ENDPOINTS = {
  BASE_URL: ENV_CONFIG.api.base,
  VENDEDOR: {
    PERFIL: ENV_CONFIG.endpoints.vendedor.perfil,
  },
  VENTA: {
    BASE_URL: ENV_CONFIG.api.ventas,
    SALDO: ENV_CONFIG.endpoints.venta.saldo,
    PAQUETES: ENV_CONFIG.endpoints.venta.paquetes,
    SELECCIONAR_OFERTA: ENV_CONFIG.endpoints.venta.seleccionarOferta,
    RESUMEN: ENV_CONFIG.endpoints.venta.resumen,
    DETALLE: ENV_CONFIG.endpoints.venta.detalle,
  },
  PASSWORD: {
    RESET_REQUEST: ENV_CONFIG.endpoints.password.resetRequest,
    VALIDATE_TOKEN: ENV_CONFIG.endpoints.password.validateToken,
    CONFIRM: ENV_CONFIG.endpoints.password.confirm
  },
  ONBOARDING: {
    START: ENV_CONFIG.endpoints.onboarding.start,
    SEND_VERIFICATION: ENV_CONFIG.endpoints.onboarding.sendVerification,
    VALIDATE_TOKEN: ENV_CONFIG.endpoints.onboarding.validateToken
  },
  SUPPORT: {
    BASE_URL: ENV_CONFIG.api.support,
    TOKENS_URL: ENV_CONFIG.api.tokens,
    MODULES: ENV_CONFIG.endpoints.support.modules,
    USERS: ENV_CONFIG.endpoints.support.users,
    ROLES: ENV_CONFIG.endpoints.support.roles,
    PERMISSIONS: ENV_CONFIG.endpoints.support.permissions,
    GROUPS: ENV_CONFIG.endpoints.support.groups,
    GROUP_MAPPINGS: ENV_CONFIG.endpoints.support.groupMappings,
    USER_STATUS: ENV_CONFIG.endpoints.support.userStatus,
    USER_UNLOCK: ENV_CONFIG.endpoints.support.userUnlock
  },
  PIN: {
    BASE_URL: ENV_CONFIG.api.pin,
    CAMBIAR: ENV_CONFIG.endpoints.pin.cambiar,
  },
  RECARGAS: {
    BASE_URL: ENV_CONFIG.api.recargas,
    CONFIGURACION: ENV_CONFIG.endpoints.recargas.configuracion,
    EJECUTAR: ENV_CONFIG.endpoints.recargas.ejecutar,
  },
  COMPLIANCE: {
    BASE_URL: ENV_CONFIG.api.compliance,
    REGISTRY_DATA: ENV_CONFIG.endpoints.compliance.registryData,
    REGISTRY_PHOTO: ENV_CONFIG.endpoints.compliance.registryPhoto,
    REGISTRY_FINAL: ENV_CONFIG.endpoints.compliance.registryFinal,
  },
  REPORTES: {
    BASE_URL: ENV_CONFIG.api.reportes,
    RESUMEN: ENV_CONFIG.endpoints.reportes.resumen,
    DETALLE: ENV_CONFIG.endpoints.reportes.detalle,
  },
} as const;

export const TIMEOUT_CONFIG = {
  DEFAULT: ENV_CONFIG.timeout.default,
  PRETUPS: ENV_CONFIG.timeout.pretups,
  MAX_RETRIES: ENV_CONFIG.timeout.maxRetries
} as const;
